module.exports = __webpack_public_path__ + "c779c056b72036843cc113678c5e2b78.jpg";